var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 90,
    viewBox: "0 0 101 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.125 0C79.4583 0 86.4383 3.08333 92.065 9.25C97.6917 15.4167 100.503 22.75 100.5 31.25C100.5 32.75 100.417 34.23 100.25 35.69C100.083 37.15 99.7917 38.5867 99.375 40H68.125L59.625 27.25C59.2083 26.5833 58.625 26.0417 57.875 25.625C57.125 25.2083 56.3333 25 55.5 25C54.4167 25 53.4383 25.3333 52.565 26C51.6917 26.6667 51.0867 27.5 50.75 28.5L44 48.75L39.625 42.25C39.2083 41.5833 38.625 41.0417 37.875 40.625C37.125 40.2083 36.3333 40 35.5 40H1.625C1.20833 38.5833 0.916666 37.1467 0.75 35.69C0.583333 34.2333 0.5 32.795 0.5 31.375C0.5 22.7917 3.29167 15.4167 8.875 9.25C14.4583 3.08333 21.4167 0 29.75 0C33.75 0 37.5217 0.791666 41.065 2.375C44.6083 3.95833 47.7533 6.16667 50.5 9C53.1667 6.16667 56.2717 3.95833 59.815 2.375C63.3583 0.791666 67.1283 0 71.125 0ZM50.5 90C49 90 47.5633 89.73 46.19 89.19C44.8167 88.65 43.5867 87.8367 42.5 86.75L9 53.125C8.5 52.625 8.04167 52.125 7.625 51.625C7.20833 51.125 6.79167 50.5833 6.375 50H32.75L41.25 62.75C41.6667 63.4167 42.25 63.9583 43 64.375C43.75 64.7917 44.5417 65 45.375 65C46.4583 65 47.4583 64.6667 48.375 64C49.2917 63.3333 49.9167 62.5 50.25 61.5L57 41.25L61.25 47.75C61.75 48.4167 62.375 48.9583 63.125 49.375C63.875 49.7917 64.6667 50 65.5 50H94.5L93.25 51.5L92 53L58.375 86.75C57.2917 87.8333 56.0833 88.6467 54.75 89.19C53.4167 89.7333 52 90.0033 50.5 90Z",
    fill: "url(#paint0_linear_168_3577)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_168_3577",
    x1: 0.5,
    y1: 45,
    x2: 100.5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartVector);
export default __webpack_public_path__ + "static/media/heartVector.1782c2456ec13d0b8e6dc93e7eddcd93.svg";
export { ForwardRef as ReactComponent };